import clsx from "clsx";
import { FC } from "react";

import { CourseCodeGroupingView } from "./CourseGroupingView";
import { CourseCodeNavList } from "./CourseNavList";

import type { CourseViewOption } from "components/menus/SectionViewOptionMenu";
import { useIsMdOrLarger } from "mds/hooks/use-responsive";
import { useAppSelector } from "store/index";
import { selectHasCourseCodes, selectIsEditingOrgSettings } from "store/selectors";

const COURSE_CODE_EVENT_PREFIX = "Home - Course Catalog / ";

export const CourseCodeView: FC<{ onOptionChange: (option: CourseViewOption) => void }> = ({
  onOptionChange,
}) => {
  const hasCourseCodes = useAppSelector(selectHasCourseCodes);
  const canEdit = useAppSelector(selectIsEditingOrgSettings);
  const isSmallScreen = !useIsMdOrLarger();

  return (
    <div
      className={clsx(
        "flex h-full w-full items-start",
        isSmallScreen && "flex-col overflow-y-auto pb-4",
      )}
    >
      {hasCourseCodes && <CourseCodeNavList canEdit={canEdit} onOptionChange={onOptionChange} />}

      <main className={clsx("w-full", !isSmallScreen && "h-full flex-auto overflow-y-auto")}>
        <CourseCodeGroupingView canEdit={canEdit} eventPrefix={COURSE_CODE_EVENT_PREFIX} />
      </main>
    </div>
  );
};
